import { motion } from 'framer-motion';

export default function SplitText({
  text = '',
  delay = 0.05,
  duration = 0.6,
  splitType = 'words',
  className = '',
  startDelay = 0,
  as = 'span',
}) {
  const MotionTag = motion[as] || motion.span;
  const parts = splitType === 'chars' ? Array.from(text) : text.split(' ');

  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: delay, delayChildren: startDelay } },
  };
  const child = {
    hidden: { y: '110%', opacity: 0 },
    visible: { y: '0%', opacity: 1, transition: { duration, ease: [0.16, 1, 0.3, 1] } },
  };

  return (
    <MotionTag
      className={`rb-split ${className}`}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.4 }}
      aria-label={text}
    >
      {parts.map((part, i) => (
        <span className="rb-split__mask" key={`${part}-${i}`} aria-hidden>
          <motion.span className="rb-split__part" variants={child}>
            {part}
            {splitType === 'words' && i < parts.length - 1 ? ' ' : ''}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}
